import React from "react"
import { FaAdobe, FaChessKing, FaTachometerAlt } from "react-icons/fa"

export default [
  {
    icon: <FaAdobe />,
    title: "Huntsville Health System Huntsville Alabama",
    text: "Currently serving as a Physician Track Analyst providing system optimization, testing, and validation of dynamic documentation note templates, workflow mPages, custom auto-text and provider powerforms (Procedure, Scales/ Assessments). Collaborate with Provider subject matter experts on current and future state workflows and specialty documentation.",
  },
  {
    icon: <FaChessKing />,
    title: "Health Quest Medical Poughkeepsie NY",
    text: "I was previously working on a 6 month contract where I provided live support for client during Registration/Schedule and CPM Billing implementation. Provided workflow gap analysis and process redesign recommendations.",
  },
  {
    icon: <FaTachometerAlt />,
    title: "Apex Systems Kansas City, MO",
    text: "Partnered with various Healthcare groups, to train end users and monitor issues with implementation. Utilized strategical and tactical approaches to meet end user and business needs.",
  },
]
